<template lang="">
  <div id="content">
    <div class="global_area">
      <div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>거래서 수정</strong></div>
      <h2 class="h_sub">거래처 수정<span class="fs_regular">[보기&amp;수정]</span></h2>
    </div>

    <MerchantManageEditForm :authSeq="authSeq"/>
  </div>
</template>

<script>
import MerchantManageEditForm from '@/components/admin/merchant/MerchantManageEditForm.vue';

export default {
  props: {
    authSeq: {
      type: String,
      required: true
    }
  },
  components: {
    MerchantManageEditForm
  }
    
}
</script>
<style lang="">
    
</style>